import { SvgIcon, SvgIconProps } from '@mui/material';
import './ccf-overall-sentiment-sad-icon.module.scss';

/* eslint-disable-next-line */
export interface CcfOverallSentimentSadIconProps extends SvgIconProps {}

/**
 * Component to render overall sentiment icon for minimum score in RTIG
 * @param props - CcfOverallSentimentSadIconProps
 * @example <CcfOverallSentimentSadIcon />
 * @returns
 */
export function CcfOverallSentimentSadIcon(
  props: CcfOverallSentimentSadIconProps
) {
  return (
    <SvgIcon
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.6 7.36C6.48 7.36 7.2 6.64 7.2 5.76C7.2 4.88 6.48 4.16 5.6 4.16C4.72 4.16 4 4.88 4 5.76C4 6.64 4.72 7.36 5.6 7.36ZM10.4 7.44C11.28 7.44 12 6.72 12 5.84C12 4.96 11.28 4.24 10.4 4.24C9.52 4.24 8.8 4.96 8.8 5.84C8.8 6.72 9.52 7.44 10.4 7.44ZM11.76 10.72C10.8 9.6 9.44 8.96 8 8.96C6.48 8.88 5.04 9.6 4.08 10.8C3.84 11.12 3.84 11.6 4.16 11.84C4.32 11.92 4.48 12 4.64 12H11.44C11.76 12 12.08 11.76 12.08 11.44C12.08 11.12 12 10.88 11.76 10.72ZM8 0C3.6 0 0 3.6 0 8C0 12.4 3.6 16 8 16C12.4 16 16 12.4 16 8C16 3.6 12.4 0 8 0ZM8 14.4C4.48 14.4 1.6 11.52 1.6 8C1.6 4.48 4.48 1.6 8 1.6C11.52 1.6 14.4 4.48 14.4 8C14.4 11.52 11.52 14.4 8 14.4Z"
        fill="#B72424"
      />
    </SvgIcon>
  );
}

export default CcfOverallSentimentSadIcon;
